import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { CustomButton, CustomTable } from '../../shared/uiComponents';
import { useCheckPermission, useScreenWidth } from '../../shared/Helpers/hooks';
import { AdminTypes } from '../../components/Menu';
import SearchBar from '../../components/SearchBar';
import { Container, Header } from '../../components/StyledComponents';
import { PERMISSIONS } from '../../App/constants';
import { Headers, TableBody } from './tableInfo';
import MobileView from './mobileView';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getClinicalSupervisors } from '../../redux/State/userSlice';
import { UserCrown } from '../../shared/Assets/menuIcons';
import { PageHeader } from '../../components/PageHeader';
import { PlusIcon } from '../../shared/Assets/svg';

const ClinicalSupervisor = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<DispatchProperties>();
	const { permissionGranted } = useCheckPermission(PERMISSIONS.USER.CREATE);
	const [params] = useSearchParams();

	const usersData = useSelector((state) => state.user.clinicalSupervisors);
	const loading = useSelector((state) => state.user.loading);

	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	useEffect(() => {
		const page = params.get('page') || '1';
		const pageSize = params.get('pageSize') || '8';
		const orderBy = params.get('orderBy') || '';
		const direction = params.get('direction') || '';
		const searchString = params.get('search') || '';

		dispatch(
			getClinicalSupervisors({
				page,
				pageSize,
				orderBy,
				direction,
				searchString,
			}),
		);
	}, [params, dispatch]);

	const addClinicalSupervisorHandler = () => {
		window.localStorage.setItem('formType', AdminTypes[3]);
		navigate('/cs/new');
	};

	const headerContent = (
		<>
			{' '}
			<SearchBar style={{ marginTop: 0 }} />
			{permissionGranted && (
				<CustomButton title="Add Clinical Supervisor" onClick={addClinicalSupervisorHandler} startIcon={<PlusIcon />} />
			)}
		</>
	);

	return (
		<>
			{isMobile ? (
				<MobileView {...usersData} />
			) : (
				<Container>
					<Header>
						<PageHeader icon={<UserCrown />} title="Clinical Supervisor" isInContainer headerContent={headerContent} />
					</Header>
					<CustomTable headers={Headers} data={usersData} TableBody={TableBody} loading={loading} />
				</Container>
			)}
		</>
	);
};

export default ClinicalSupervisor;
